<p style="opacity: 0;">App loading...</p>